import React from "react";
import styled from "styled-components";

const RecSection = ({ isPublic, division }) => {
  if (isPublic) return null;

  return (
    <SectionCard>
      <SectionHeader>RECS</SectionHeader>
      <RecText>
        Recuerda publicar las recs en el canal de discord{" "}
        {division ? (
          <RecChannel>
            #{division.name.replace(" ", "-").toLowerCase()}-recs
          </RecChannel>
        ) : null}
      </RecText>
    </SectionCard>
  );
};

const SectionCard = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
`;

const SectionHeader = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-mint);
  margin: 0 0 0.75rem;
`;

const RecText = styled.p`
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg);
  margin: 0;
`;

const RecChannel = styled.span`
  color: var(--v-gold);
  font-weight: 600;
`;

export default RecSection;
